"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Input = require("@ccw-pwa-ui/Input");
var _Switch = require("@ccw-pwa-ui/Switch");
require("../styles/SystemDetailComponentStyle.css");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
const ServiceHistoryDetails = _ref => {
  let {
    handleCancle,
    backNavigationScreen,
    handleBack,
    rightNavHeading,
    headerText,
    subContent,
    pretreatmentChecked,
    saveBtnClick,
    saveBtnDisabled,
    isRo,
    currentPage,
    totalPage,
    subHeaderText,
    details,
    inletTdsChanged,
    onChangeInletTds,
    inletHardnessChanged,
    onChangeInletHardness,
    inletTempChanged,
    onChangeInletTemp,
    inletPressureChanged,
    onChangeInletPressure,
    pressureDropChanged,
    onChangepressureDrop,
    permeateTdsChanged,
    onChangePermeateTds,
    rejectTdsChanged,
    onChangeRejectTds,
    permeateFlowRateChanged,
    onChangePermeateFlowRate,
    rejectedFlowChanged,
    onChangeRejectedFlow,
    blendedTdsChanged,
    onChangeBlendedTds,
    recoveryChanged,
    onChangeRecovery,
    pretreatmentValue,
    subText,
    preChargeChanged,
    onChangePreCharge,
    isUpdating,
    showSteps = true,
    saveButtonTitle,
    onKeyPress
  } = _ref;
  const suffixValue = suffix => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "suffix_style"
    }, suffix);
  };
  return isUpdating ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: backNavigationScreen,
    handleBack: handleBack,
    handleCancle: handleCancle,
    leftArrowImage: _index.default.leftArrow.default,
    rightNavHeading: rightNavHeading
  }), showSteps ? /*#__PURE__*/_react.default.createElement("div", {
    className: "PageCount",
    style: {
      paddingLeft: 22,
      paddingTop: 15,
      fontFamily: "poppins",
      fontSize: 18
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), " of ", totalPage) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-body-inner-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "header-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "subContent",
    "data-testid": "sub-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subContent
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sub-header"
  }, "   ", /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subText,
    headerStyle: {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0px',
      textAlign: 'left'
    }
  }))), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: subHeaderText,
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "22px"
    },
    variant: "simple-text"
  }), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "Inlet-val",
    className: "sub-header"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px",
        top: '20px'
      },
      variant: "header-text",
      headerText: "Raw Water TDS"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: inletTdsChanged ? "#000000" : null
      },
      suffix: suffixValue('ppm'),
      value: details === null || details === void 0 ? void 0 : details.InletTds,
      onchange: onChangeInletTds,
      testId: "inlet-tds"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pretreatment-container",
    "data-testid": "pretreatment-val"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "22px"
    },
    variant: "header-text",
    headerText: 'Water Softener Pretreatment Installed'
  }), /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
    defaultChecked: true,
    checked: pretreatmentValue,
    disabled: false,
    onChange: pretreatmentChecked,
    checkedChildren: "Yes",
    unCheckedChildren: "No",
    testId: "pretreatment-switch"
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "Inlet-hardness"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Raw water Hardness"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: inletHardnessChanged ? "#000000" : null
      },
      suffix: suffixValue('gpg'),
      value: details === null || details === void 0 ? void 0 : details.InletHardness,
      onchange: onChangeInletHardness,
      testId: "inlet-hardness"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "inlet-temp"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Raw Water Temperature"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: inletTempChanged ? "#000000" : null
      },
      suffix: suffixValue('F'),
      value: details === null || details === void 0 ? void 0 : details.InletTemp,
      onchange: onChangeInletTemp,
      testId: "input-inlet-temp"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "inlet-pressure"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Raw Water Pressure"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: inletPressureChanged ? "#000000" : null
      },
      suffix: suffixValue('psi'),
      value: details === null || details === void 0 ? void 0 : details.InletPressure,
      onchange: onChangeInletPressure,
      testId: "input-inlet-pressure"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pre-filter"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Pre-Filter pressure drop"
    },
    onKeyPress: onKeyPress,
    inputType: "lable-input-error",
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: pressureDropChanged ? "#000000" : null
      },
      suffix: suffixValue('psid'),
      value: details === null || details === void 0 ? void 0 : details.pressureDrop,
      onchange: onChangepressureDrop,
      testId: "input-pressure-drop"
    }
  })), isRo && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "other-notes"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "permeate-tds"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Permeate Water TDS"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: permeateTdsChanged ? "#000000" : null
      },
      suffix: suffixValue('ppm'),
      value: details === null || details === void 0 ? void 0 : details.PermeateTds,
      onchange: onChangePermeateTds,
      testId: "input-permeate-tds"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "blended-tds"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Blended Water TDS "
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: blendedTdsChanged ? "#000000" : null
      },
      suffix: suffixValue('ppm'),
      value: details === null || details === void 0 ? void 0 : details.BlendedTds,
      onchange: onChangeBlendedTds,
      testId: "input-blended-tds"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "reject-tds"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Concentrate TDS"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: rejectTdsChanged ? "#000000" : null
      },
      suffix: suffixValue('ppm'),
      value: details === null || details === void 0 ? void 0 : details.RejectTds,
      onchange: onChangeRejectTds,
      testId: "input-rejected-tds"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "fow-rate"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Production Flow Rate"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: permeateFlowRateChanged ? "#000000" : null
      },
      suffix: suffixValue('ml/min'),
      value: details === null || details === void 0 ? void 0 : details.PermeateFlowRate,
      onchange: onChangePermeateFlowRate,
      testId: "input-permeate-flow-rate"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "reject-flow"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Waste Flow Rate"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: rejectedFlowChanged ? "#000000" : null
      },
      suffix: suffixValue('ml/min'),
      value: details === null || details === void 0 ? void 0 : details.RejectedFlow,
      onchange: onChangeRejectedFlow,
      testId: "input-rejected-flow"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pre-charge"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Pre-charge pressure in bladder tank(s)(when empty)"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      placeholder: "Enter Value",
      type: "number",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: preChargeChanged ? "#000000" : null
      },
      suffix: suffixValue('psi'),
      value: details === null || details === void 0 ? void 0 : details.preCharge,
      onchange: onChangePreCharge,
      testId: "input-pre-charge"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "recovery"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    containerStyle: "container-style",
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#9A9A9A',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Recovery"
    },
    inputType: "lable-input-error",
    onKeyPress: onKeyPress,
    inputProps: {
      disabled: true,
      placeholder: "",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px",
        top: '10px',
        borderColor: recoveryChanged ? "#000000" : null
      },
      suffix: suffixValue('%'),
      testId: "recovery-val",
      value: details === null || details === void 0 ? void 0 : details.Recovery,
      onchange: onChangeRecovery
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "other-notes",
    "data-testid": "continue-press"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: saveButtonTitle || 'Save and Continue',
    onClick: saveBtnClick,
    disabled: saveBtnDisabled
  })))));
};
var _default = exports.default = ServiceHistoryDetails;